import { Injectable, inject } from '@angular/core';
import { ServicesService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class InteractionEndpointsService {
  readonly #service = inject(ServicesService);

  public attempt() {
    return this.#service.thor(`attempt`);
  }

  public draft() {
    return this.#service.thor(`draft`);
  }

  public selfScore() {
    return this.#service.thor(`self-score`);
  }

  public close(arrangementCode: string, contentIdentifier: string) {
    return this.#service.thor(
      `attempt/${arrangementCode}/${contentIdentifier}/close`,
    );
  }

  public resultById(arrangementCode: string, contentIdentifier: string) {
    return this.#service.thor(
      `result/content/${arrangementCode}/${contentIdentifier}`,
    );
  }

  public clearResultById(arrangementCode: string, contentIdentifier: string) {
    return this.#service.thor(
      `attempt/${arrangementCode}/${contentIdentifier}/all`,
    );
  }

  public progressById(arrangementCode: string, contentIdentifier: string) {
    return this.#service.thor(
      `score/content/${arrangementCode}/${contentIdentifier}`,
    );
  }

  public progressByParagraphPath(
    arrangementCode: string,
    paragraphPath: string,
  ) {
    return this.#service.edition(
      `progress/arrangement/${arrangementCode}/${paragraphPath}`,
    );
  }

  public recentScoreOverall() {
    // return this.#service.thor(`score/recent`);
    return this.#service.edition('progress');
  }

  public recentScoreForMethod(methodSlug: string) {
    // return this.#service.thor(`score/recent/method/${methodSlug}`);
    return this.#service.edition(`progress/method/${methodSlug}`);
  }

  public recentScoreForArrangement(arrangementCode: string, useThor = false) {
    if (useThor) {
      return this.#service.thor(`score/recent/${arrangementCode}`);
    }

    return this.#service.edition(`progress/arrangement/${arrangementCode}`);
  }

  public answerById(arrangementCode: string, contentIdentifier: string) {
    return this.#service.thor(`answer/${arrangementCode}/${contentIdentifier}`);
  }

  public feedbackById(arrangementCode: string, contentPath: string) {
    return this.#service.edition(
      `feedback/arrangement/${arrangementCode}/${contentPath}`,
    );
  }

  public startSelfTest() {
    return this.#service.thor('sequence/start');
  }

  public submitSelfTest() {
    return this.#service.thor('sequence/submit');
  }

  public completeSelfTest() {
    return this.#service.thor('sequence/end');
  }

  public deleteSelfTest() {
    return this.#service.thor('sequence/delete');
  }
}
